import { useQuery } from '@tanstack/react-query';

import { api } from '../../../core/network/api';
import { animalKeys } from '../queries/keys';
import { animalPaths } from '../queries/paths';

// TSS vite/03 — Desglose reproductivo OPU de una donadora (admin-animals.md · 0109/Tier 98).
// GET /admin/animals/:id/opu-breakdown → { sessions, placements }. Read-only, kpis:read.
// `session_donor_count` = co-aspiración (conteo neutral, sin identidades). `birth` = cría nacida
// ligada a la transferencia o null.
export function useOpuBreakdown(animalId) {
    return useQuery({
        queryKey: animalKeys.opuBreakdown(animalId),
        queryFn:  ({ signal }) => api.get(animalPaths.opuBreakdown(animalId), { signal }).then(r => r.data),
        enabled:  !!animalId,
    });
}
